import React, { Component } from 'react'
import { connect } from '@cerebral/react'
import getPositions from './getPositions'
import styles from './styles'
import { css } from 'aphrodite'
import getItemStyles from './getItemStyles'
import { state } from 'cerebral/tags'

class MediaDragLayer extends Component {
  constructor(props) {
    super(props)
    this.onMouseMove = this.onMouseMove.bind(this)
    this.state = { x: 0, y: 0 }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.mediaDragging) {
      document.removeEventListener('mousemove', this.onMouseMove, false)
      document.addEventListener('mousemove', this.onMouseMove, false)
    } else {
      document.removeEventListener('mousemove', this.onMouseMove, false)
    }
  }

  onMouseMove(e) {
    this.setState({ x: e.clientX, y: e.clientY })
  }

  render() {
    const { keys, mediaDragging, selectedFiles, canDropMedia } = this.props
    const count = selectedFiles.length
    const { x, y } = this.state
    if (!mediaDragging || count === 0) {
      return null
    }

    const { marginTop, width, copy } = getPositions(count)

    const copyKey = Object.keys(keys).reduce((acc, key) => {
      if ((key === '18' || key === '17') && keys[key]) {
        acc = true
      }
      return acc
    }, false)

    return (
      <div className={css(styles.container)}>
        <div style={getItemStyles({ x, y, width, canDropMedia })}>
          <div className={css(styles.countContainer)} style={{ marginTop }}>
            {count}
          </div>
          {copyKey ? (
            <span className={css(styles.copy)} style={copy}>
              +
            </span>
          ) : null}
        </div>
      </div>
    )
  }
}

export default connect(
  {
    selectedFiles: state`media.selectedFiles`,
    canDropMedia: state`media.canDropMedia`,
    mediaDragging: state`media.dragging`,
    keys: state`media.keyboard.keys`
  },
  MediaDragLayer
)



// WEBPACK FOOTER //
// ./src/components/Media/DragLayer/mediaDragLayer.js